import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import { css } from "@emotion/react";
import { capitalize } from "lodash";
import FavoritePropertyButton from "@components/property-card/favoriteButton";
import SharedNetWork from "@components/shared-network";
import { AlbumCodeShareCss } from "../styles";
import React from "react";
interface AlbumHeaderProps {
  isCollection: boolean;
  id: number;
  isFavorite: boolean | null;
  onFavoriteChange: (isFavorite: boolean) => void;
  detail: any;
  parent_id: number;
}

const AlbumHeader = ({
  isCollection,
  id,
  isFavorite,
  onFavoriteChange,
  detail,
  parent_id,
}: AlbumHeaderProps) => {
  return (
    <Grid container alignItems="flex-end" width="100%">
      <Grid item xs="auto">
        {isCollection && (
          <AlbumCode isCollection={isCollection}>
            <AlbumCodeText>COLLECTION ® </AlbumCodeText>
            Código: {id}
          </AlbumCode>
        )}
        {!isCollection && <AlbumCode>Código: {id}</AlbumCode>}
      </Grid>

      <Grid flex={1} />

      <Grid item xs="auto">
        <AlbumLikeContainer>
          <FavoritePropertyButton
            fontSize="medium"
            borderColor="error"
            size={50}
            parent_id={parent_id}
            is_favorite={isFavorite}
            detail={detail}
            onChangeCallback={onFavoriteChange}
          />
          <AlbumLikeText>{isFavorite ? "Quitar" : "Guardar"}</AlbumLikeText>
        </AlbumLikeContainer>
      </Grid>

      <Grid item xs="auto">
        <SharedNetWork>
          <AlbumShare>
            <AlbumShareIcon
              src="/icons/icon_share_remaxrd_white.svg"
              alt="Icono Compartir"
            />
            <AlbumShareText>Compartir</AlbumShareText>
          </AlbumShare>
        </SharedNetWork>
      </Grid>
    </Grid>
  );
};

const AlbumLikeContainer = styled.div`
  display: flex;
  background-color: white;
  border-radius: 20px 0 0 0;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
  align-items: center;
  width: 130px;
  height: 45px;
  padding: 0 10px;
  @media screen and (max-width: 991px) {
    width: 80px;
    height: 50px;
  }
  @media screen and (max-width: 570px) {
    right: 0;
  }
`;

const AlbumCode = styled.p<{ isCollection?: boolean }>`
  ${AlbumCodeShareCss};
  background-color: var(--color-brand-blue-secondary);
  text-align: center;
  padding: 1rem 1.5rem;
  color: var(--color-brand-bg-secondary);
  font-weight: 500;
  font-size: ${17 / 16 + "rem"};
  text-decoration: none;
  border-radius: 20px 20px 0 0;
  display: inline-block;
  width: auto;
  margin-top: 40px;

  ${(props) => {
    if (props.isCollection) {
      return css`
        background-color: #ec1c25;
      `;
    }
  }}

  @media screen and (max-width: 991px) {
    white-space: nowrap;
    font-size: 0.9rem;
  }
`;

const AlbumCodeText = styled.span`
  color: var(--color-brand-bg-secondary);

  @media screen and (max-width: 570px) {
    display: none;
  }
`;

const AlbumShare = styled.p`
  ${AlbumCodeShareCss};
  background-color: var(--color-brand-blue-main);
  border-radius: 0px 20px 0 0;
  font-weight: 500;
  display: flex;
  gap: 10px;
  font-size: ${14 / 16 + "rem"};
  padding: 0 10px;
  height: 45px;
  cursor: pointer;

  &:hover {
    color: var(--color-brand-grey-main);
  }

  @media screen and (max-width: 991px) {
    width: 80px;
    height: 50px;
  }
`;

const AlbumLikeText = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: var(--color-brand-blue-main);
  margin-right: 10px;

  @media screen and (max-width: 991px) {
    display: none;
  }
`;

const AlbumShareText = styled.span`
  color: #fff;
  padding-top: 5px;

  @media screen and (max-width: 991px) {
    display: none;
  }
`;

const AlbumShareIcon = styled.img`
  color: var(--color-brand-red-main);
  margin-left: 5px;
  margin-top: 5px;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  border-style: none;
  @media screen and (max-width: 991px) {
    margin-left: 0;
  }
`;

export default AlbumHeader; 